import Header from './components/Header';
import Footer from './components/Footer';
import HeroSection from './components/HeroSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <CommentsSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <FeaturesSection />
        <TopicsSection />
        <RankingSection />
        <CardsSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}